"use strict";

import angular from "angular";

import tippy from "tippy.js";

const name = "tippyTooltip";
const factory = [
    () => ({
        restrict: "A",
        scope: {
            tippyTooltip: "@",
            tippyPlacement: "@"
        },
        link: ($scope, $elem, $attr) => {
            // A instância só nasce quando há texto: o atributo também fica em elementos que quase
            // nunca têm tooltip (o card de indicador só tem no drill down de grupo), e criar uma
            // por card em todo dashboard era custo sem uso.
            let context = null;
            $scope.$watch(
                () => $scope.tippyTooltip,
                (newValue) => {
                    if (context) return context.setContent(newValue || "");
                    if (!String(newValue || "").trim()) return;
                    context = tippy($elem[0], {
                        content: newValue,
                        placement: $scope.tippyPlacement || "bottom",
                        allowHTML: true,
                        theme: "default",
                        onShow(instance) {
                            if (!instance.props.content.trim()) {
                                return false;
                            }
                        }
                    });
                }
            );
            /**
             * O Tippy pendura o balão no `document.body`, fora da árvore do Angular. Sem este
             * destroy, sair da tela removia só o elemento que dispara o tooltip -- a instância
             * e o balão continuavam vivos no body, e o "Pesquisar empresa" reaparecia flutuando
             * por cima de outras telas.
             *
             * `$destroy` do escopo isolado cobre os dois caminhos de saída: troca de rota e
             * remoção por `ng-if`/`ng-repeat`.
             */
            $scope.$on("$destroy", () => context?.destroy());
        }
    })
];
angular.module("nucont.shared").directive(name, factory);
export default { name, factory };
